import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { logoutApplication } from '../../components/layout/Header'
import { getOs } from '../../utils/utility'
import { getCardDetails, getEnrolledMemberData, gethealthcard, getProgramInfo, getproviderLink, getRxSimpleShareData } from '../ApiCall'
import NotificationIcon from '../Images/NewIcons/my notifications icon (active).svg'
import moment from 'moment'
import { Modal } from 'react-bootstrap'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import CommonLoader from '../CommonLoader'

export default class LeftDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: localStorage.getItem('subscriberName'),
      id: false,
      link: 'https://members.myflexcare.com/login/member',
      fliptLink: '',
      showmyneeds: false,
      dashboardCards: [],
      pharmaShow: false,
      isRevive: false,
      reviveLink:"",
    }
    this.closeparentdrawer = this.closeparentdrawer.bind(this)
    this.opendocuments = this.opendocuments.bind(this)
    this.opencontacts = this.opencontacts.bind(this)
  }

  componentDidMount() {
    gethealthcard().then(resp => {
      let data = {
        memberSSN: resp.data.memberIdCardList[0].memberSSN,
        type: 'family'
      }
      getRxSimpleShareData(data).then(res => {
        if (res && Array.isArray(res)) {
          res.map(value => {
            if (value.addon.includes('RxSimpleShare') && value.status === 'AC') this.setState({ pharmaShow: true }, ()=>{
              localStorage.setItem("pharmaShow", true)
            })
            if (value.addon.includes('Health Tools') && value.status === 'AC') this.setState({ isTelemed: true }, ()=>{
              localStorage.setItem("isTelemed", true)
            })
            if (value.addon.includes('UHSRx') && value.status === 'AC') this.setState({ isRevive : true }, ()=>{
              localStorage.setItem("isRevive", true)
            })
          })
        }
      })
      getProgramInfo()
      .then(res => {
        if (res.data && res.data.programInfo) {
          var str = res.data.programInfo.programName
          if (str.includes('+')) {
            var str1 = res.data.programInfo.programName
            var res1 = str1.split(' ')
            this.setState({ programname: res1[0], programname2: ' with ' + res1[2], showwithacsm: true })
          } else {
            this.setState({ programname: res.data.programInfo.programName, showwithacsm: false })
          }
        } else {
          this.setState({ loader: false })
        }
      })
      .catch()
    })
    var os = getOs()

    if (os == 'Mac OS') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://apps.apple.com/us/app/southern-scripts/id938009409',
        reviveLink:'https://apps.apple.com/us/app/revivehealth-mobile/id6450846042' })
    }
    if (os == 'iOS') {
      this.setState({
        link: 'https://members.myflexcare.com/login/member',
        fliptLink: 'https://apps.apple.com/us/app/southern-scripts/id938009409',
        reviveLink:'https://apps.apple.com/us/app/revivehealth-mobile/id6450846042'
      })
    }
    if (os == 'Windows') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://member.liviniti.com/home',
        reviveLink:'https://member.myrevive.health/' })
    }
    if (os == 'Android') {
      this.setState({
        link: 'https://members.myflexcare.com/login/member',
        fliptLink: 'https://play.google.com/store/apps/details?id=org.yappymobile.southernscripts&pli=1',
        reviveLink:'https://play.google.com/store/apps/details?id=health.revive.mobile&hl=en_US&pli=1'
      })
    }
    if (os == 'Linux') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://member.liviniti.com/home',
        reviveLink:'https://member.myrevive.health/' })
    }

    getCardDetails().then(res => {
      if (res.data.response) {
        // Keep original response items
        let apiItems = [...res.data.response]
        // Ensure CuramLifeCard is present if ProgramInformation exists
        const hasProgramInfo = apiItems.some(item => item.cardtitle === 'ProgramInformation')
        const hasCuram = apiItems.some(item => item.cardtitle === 'CuramLifeCard')
        if (hasProgramInfo && !hasCuram) apiItems.push({ cardtitle: 'CuramLifeCard' })

        // Create a lookup by cardtitle for easy reuse
        const itemMap = {}
        apiItems.forEach(item => {
          itemMap[item.cardtitle] = item
        })

        // Desired sequence (only the mapped items are re-ordered here). Static links (Dashboard, Notifications, Notices)
        // remain where they are. Member Education and Sign Out remain after this list.
        const desiredOrder = [
          'MembershipId', // ID Card
          'ProgramInformation',
          'Documents',
          'MyNeeds',
          'MyTransaction', // Payments / Transactions
          'ContactInformation',
          'FindProvider', // Provider
          'HealthQuestionnaire',
          'FAQs',
          'Telemedicine', // synthetic / conditional (will be rendered based on state)
          'RxSimpleShare', // synthetic / conditional
          'UHSRx', // synthetic / conditional
          'CuramLifeApp', // synthetic -> openCuramLink
          'CuramLifeCard' // Wellness Center
        ]

        // Build ordered array from desiredOrder. If API provided an item, use it; otherwise create a minimal object
        const ordered = []
        desiredOrder.forEach(key => {
          if (itemMap[key]) ordered.push(itemMap[key])
          else ordered.push({ cardtitle: key, enable: true })
        })

        this.setState({ dashboardCards: ordered })
      }
    })
  }
  openCuramLink=() => {
    var os = getOs()
    if (os == 'Mac OS'||os == 'Windows'||os == 'Linux')
    window.open("https://www.universalhealthfellowship.org/curamlife-care-coordination-app/")
    else if (os == 'iOS')
    window.open("https://apps.apple.com/us/app/curamlife/id1609101662")
    else if(os == 'Android')
    window.open("https://play.google.com/store/apps/details?id=com.curamlife")
  }
  closeparentdrawer(enable) {
    if (enable) {
      this.props.drawercloseparent(false)
    } else {
      this.props.openTempModal()
    }
  }

  openExpenseCard() {
    this.props.drawercloseExpenseOpen(false)
  }

  opendocuments() {
    this.props.documentsopen(false)
  }

  handleSignout = () => {
    logoutApplication()
  }

  opennotices(enable) {
    if (enable) {
      window.open('https://www.universalhealthfellowship.org/notices/')
    } else {
      this.props.openTempModal()
    }
  }

  opencontacts() {
    this.props.contactopen(false)
  }
  
  openccuramlife = () => {
    // console.log("::::::::::::::::: props ", this.props)
    // this.props.
    this.props.openccuramlife(true)
  }

  openprovider(enable) {
    if (enable) {
     
      getproviderLink().then(res => {
        if (res.data && res.data.length > 0) {
          var windowReference = window.open()
          let providerLink = res.data[0].fieldValue
          windowReference.location = providerLink
        } else {
          alert('Data Not Availabe')
        }
      })
    } else {
      this.props.openTempModal()
    }
  }

  openfaqs(enable) {
    if (enable) {
      window.open('https://www.universalhealthfellowship.org/FAQs/')
    } else {
      this.props.openTempModal()
    }
  }

  openhealthcard() {
    this.setState({ id: true })
  }

  opentelemed() {
    window.open(this.state.link)
  }
  openFlipt = () => {
    window.open(this.state.fliptLink)
  }
  openRevie = () => {
    window.open(this.state.reviveLink)
  }

  openFlexcareSSO = async () => {
      try {
        this.setState({ loader: true, loader: true });
        getEnrolledMemberData().then(async (res) => {
          if (res && res.data) {
            let member = res.data[0]
        const ssoResp = await fetch(process.env.REACT_APP_SSO_TOKEN_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            api_key: process.env.REACT_APP_SSO_API_KEY,
            password: process.env.REACT_APP_SSO_API_PASSWORD
          })
        });
  
        let jwtToken = ssoResp.headers.get('authorization');
        if (!jwtToken) jwtToken = ssoResp.headers.get('Authorization');
        if (!jwtToken) throw new Error('SSO token not received in headers');
  
        const accessResp = await fetch(process.env.REACT_APP_CREATE_ACCESS_TOKEN_API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          },
          body: JSON.stringify({
            membership_number: member.memberId,
            group_id: 'CLTRL',
            first_name: member.firstName,
            last_name: member.lastName,
            date_of_birth: moment(member.dateOfBirth).format('MM/DD/YYYY'),
            gender: member.gender?.toUpperCase() === "M" ? "Male" : member.gender?.toUpperCase() === "F" ? "Female" : "",
            zip: member.zipCode,
            primary_reference: ''
          })
        });
  
        const accessData = await accessResp.json();
  
        // show modal if API returned non-ok or message (eg. "User not found.")
        if (!accessResp || (accessData && 'errorid' in accessData)) {
          const msg = accessData && accessData.message ? accessData.message : 'Unable to create access token. Please contact support.';
          this.setState({ loader: false, showSSOErrorModal: true, ssoErrorMessage: "User not registered with FlexCare" });
          return;
        }
  
        const encodedUser = accessData.encoded_user;
  
        if (!encodedUser) throw new Error('encoded_user not received');
  
        window.open(`${process.env.REACT_APP_SSO_URL}${encodedUser}`, '_blank');
        this.setState({ loader: false });
        }
        })
      } catch (error) {
        console.error(error);
        this.setState({ loader: false, showSSOErrorModal: true, ssoErrorMessage: 'Flexcare SSO failed. Please contact support.' });
      }
    }

  render() {
    return (
      <div>
        {this.state.loader ? <CommonLoader /> : null}
      <div class="leftdrawer">
        <div className="ld_user_div">
          {/* <AccountCircleIcon /> */}
          <div className="ld_username">Hello <br />
           {
              localStorage.getItem('subscriberName')
                .trim()
                .toLowerCase()
                .split(/\s+/)
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ') + '!'
            }
            </div>
        </div>
        <Link
          to="/"
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'Dashboard' && 'ld_menu_container_selected'}`}
        >
          <div class="ld_image_div_container">
            <img src={require('../Images/NewIcons/dashboard icon (active).svg')} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">Dashboard</div>
        </Link>
        <Link
          to="/Notification"
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'My Notifications' && 'ld_menu_container_selected'}`}
        >
          <div class="ld_image_div_container">
            <img src={NotificationIcon} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">My Notifications</div>
        </Link>

        <Link
          to="/AnnouncementNotification"
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'Announcements' && 'ld_menu_container_selected'}`}
        >
          <div class="ld_image_div_container">
            <img src={require('../Images/NewIcons/notices icon (active).svg')} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">Announcements & Notices</div>
        </Link>
       
        {/* <Link
          to="/PaymentWallet"
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'Announcements' && 'ld_menu_container_selected'}`}
        >
          <div class="ld_image_div_container">
            <img src={require('../Images/NewIcons/payment_wallet_icon_active.svg')} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">Payment Wallet</div>
        </Link> */}
        {this.state.dashboardCards &&
          this.state.dashboardCards.map(card => (
            <>
              {(() => {
                switch (card.cardtitle) {
                  case 'Documents':
                    return (
                      <>
                        <div
                          to="/"
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          className={`ld_menu_container ${this.props.name == 'Documents' && 'ld_menu_container_selected'}`}
                          onClick={() => this.opendocuments()}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/NewIcons/documents icon (active).svg')} style={{ marginRight: '20px' }} />
                          </div>
                          <div clas="ld_menu_name">Documents</div>
                        </div>
                   
                        {this.state.isHomebase && 
                        <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          className={`ld_menu_container ${this.props.name == 'Telemed' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/LeftDrawer Icon/CuramLife_Homebase_Icon.png')} style={{ marginLeft: '-2px', width: '25px' }} />
                          </div>
                          <div clas="ld_menu_name">CuramLife Homebase App
                          <br></br><small style={{fontSize:'12px',color: '#555'}}>Medical Records powered by Docsnap</small>
                          </div>
                        </div>}
                        {/* {((this.state.isTelemed && this.state.programname?.includes("ES") || !this.state.programname?.includes("ES"))) && <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          onClick={() => this.opentelemed()}
                          className={`ld_menu_container ${this.props.name == 'Telemed' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/LeftDrawer Icon/telemed-icon-active.svg')} style={{ marginRight: '20px' }} />
                          </div>
                          <div clas="ld_menu_name" style={{marginLeft:'5px'}} >CuramLife Care Coordination App</div>
                        </div>} */}
                        {this.state.isHomebase && 
                        <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          className={`ld_menu_container ${this.props.name == 'Telemed' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/LeftDrawer Icon/CuramLife_Homebase_Icon.png')} style={{ marginLeft: '-2px', width: '25px' }} />
                          </div>
                          <div clas="ld_menu_name">CuramLife Homebase App
                          <br></br><small style={{fontSize:'12px',color: '#555'}}>Medical Records powered by Docsnap</small>
                          </div>
                        </div>}
                     
                        {/* {((this.state.isTelemed && this.state.programname?.includes("ES") || !this.state.programname?.includes("ES"))) && <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          onClick={() => this.opentelemed()}
                          className={`ld_menu_container ${this.props.name == 'Telemed' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/NewIcons/telemed icon (active).svg')} style={{ marginRight: '20px' }} />
                          </div>
                          <div clas="ld_menu_name">Telemedicine</div>
                        </div>} */}
                      </>
                    )

                  case 'FindProvider':
                    return (
                      // ( localStorage.getItem("planId")!=="10051" && localStorage.getItem("planId")!=="10052" && localStorage.getItem("planId")!=="10053"
                      // && localStorage.getItem("planId")!=="10061" && localStorage.getItem("planId")!=="10062" && localStorage.getItem("planId")!=="10063")&&
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'Find a Provider' && 'ld_menu_container_selected'}`}
                        onClick={() => this.openprovider(card.enable)}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/find a provider icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">Find a Provider</div>
                      </div>
                    )

                  case 'MembershipId':
                    return (
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'Membership Id' && 'ld_menu_container_selected'}`}
                        onClick={() => this.closeparentdrawer(card.enable)}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/membership card icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name"> Membership Card</div>
                      </div>
                    )

                  case 'ProgramInformation':
                    return card.enable ? (
                      <>
                        <>
                          <Link
                            to="/ProgramInformation"
                            style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                            class={`ld_menu_container ${this.props.name == 'Program Information' && 'ld_menu_container_selected'}`}
                          >
                            <div class="ld_image_div_container">
                              <img
                                src={require('../Images/NewIcons/program info icon (active).svg')}
                                style={{ marginRight: '20px' }}
                              />
                            </div>
                            <div clas="ld_menu_name">Program Information</div>
                          </Link>
                        </>
                        {/* 
                        <div
                          onClick={this.openccuramlife}
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          class={`ld_menu_container ${this.props.name == 'Announcements' && 'ld_menu_container_selected'}`}
                        >
                          <div class="ld_image_div_container" id="curam lifeimage">
                            <img
                              src={require('../Images/CuramLife.svg')}
                              style={{ marginRight: '20px', width: '39px', marginLeft: '-6px', height: '34px' }}
                            />
                          </div>
                          <div clas="ld_menu_name">UHF / Curam Wellness Center™</div>
                        </div>
                       */}
                      </>
                    ) : (
                      <>
                        {' '}
                        <>
                          <div
                            style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                            className={`ld_menu_container ${this.props.name == 'Program Information' && 'ld_menu_container_selected'}`}
                            onClick={() => this.props.openTempModal()}
                          >
                            <div className="ld_image_div_container">
                              <img
                                src={require('../Images/NewIcons/program info icon (active).svg')}
                                style={{ marginRight: '20px' }}
                              />
                            </div>
                            <div clas="ld_menu_name">Program Information</div>
                          </div>
                        </>
                        {/* <div
                          onClick={this.openccuramlife}
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          class={`ld_menu_container ${this.props.name == 'Announcements' && 'ld_menu_container_selected'}`}
                        >
                          <div class="ld_image_div_container" id="curam lifeimage">
                            <img
                              src={require('../Images/CuramLife.svg')}
                              style={{ marginRight: '20px', width: '39px', marginLeft: '-6px', height: '34px' }}
                            />
                          </div>
                          <div clas="ld_menu_name">UHF / Curam Wellness Center™</div>
                        </div> */}
                      </>
                    )
              

                  case 'MyNeeds':
                    return card.enable ? (
                      <Link
                        to="/MyNeeds"
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        class={`ld_menu_container ${this.props.name == 'MyNeeds' && 'ld_menu_container_selected'}`}
                      >
                        <div class="ld_image_div_container">
                          <img src={require('../Images/NewIcons/my needs icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">My Needs</div>
                      </Link>
                    ) : (
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'MyNeeds' && 'ld_menu_container_selected'}`}
                        onClick={() => this.props.openTempModal()}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/my needs icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">My Needs</div>
                      </div>
                    )

                  case 'MyTransaction':
                    return card.enable ? (
                      <Link
                        to="/Transaction"
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        class={`ld_menu_container ${this.props.name == 'MyTransactions' && 'ld_menu_container_selected'}`}
                      >
                        <div class="ld_image_div_container">
                          <img
                            src={require('../Images/NewIcons/my transactions icon (active).png')}
                            style={{ marginRight: '20px',width:25 }}
                          />
                        </div>
                        <div clas="ld_menu_name">My Payments</div>
                      </Link>
                    ) : (
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'MyTransactions' && 'ld_menu_container_selected'}`}
                        onClick={() => this.props.openTempModal()}
                      >
                        <div className="ld_image_div_container">
                          <img
                            src={require('../Images/NewIcons/my transactions icon (active).png')}
                            style={{ marginRight: '20px' }}
                          />
                        </div>
                        <div clas="ld_menu_name">My Transactions</div>
                      </div>
                    )

                  case 'HealthQuestionnaire':
                    return card.enable ? (
                      <Link
                        to="/Medical"
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        class={`ld_menu_container ${this.props.name == 'Medical Questionnaire' && 'ld_menu_container_selected'}`}
                      >
                        <div class="ld_image_div_container">
                          <img src={require('../Images/NewIcons/medical q icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">Health Questionnaire</div>
                      </Link>
                    ) : (
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'Medical Questionnaire' && 'ld_menu_container_selected'}`}
                        onClick={() => this.props.openTempModal()}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/medical q icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">Health Questionnaire</div>
                      </div>
                    )

                  case 'ContactInformation':
                    return (
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'Contact Information' && 'ld_menu_container_selected'}`}
                        onClick={() => this.opencontacts()}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/contact info icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">Contact Information</div>
                      </div>
                    )

                  case 'FAQs':
                    return (
                      <>
                      <div
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        className={`ld_menu_container ${this.props.name == 'FAQs' && 'ld_menu_container_selected'}`}
                        onClick={() => this.openfaqs(card.enable)}
                      >
                        <div className="ld_image_div_container">
                          <img src={require('../Images/NewIcons/FAQs icon (active).svg')} style={{ marginRight: '20px' }} />
                        </div>
                        <div clas="ld_menu_name">FAQs</div>
                      </div>
                         {((this.state.isTelemed && this.state.programname?.includes("ES") || !this.state.programname?.includes("ES"))) && <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          onClick={this.openFlexcareSSO}
                          className={`ld_menu_container ${this.props.name == 'Telemed' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/NewIcons/telemed icon (active).svg')} style={{ marginRight: '20px' }} />
                          </div>
                          <div clas="ld_menu_name">Telemedicine</div>
                        </div>}
                        {this.state.pharmaShow && (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && (
                          <div
                            style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                            onClick={() => this.openFlipt()}
                            className={`ld_menu_container ${this.props.name == 'flipt' && 'ld_menu_container_selected'}`}
                          >
                            <div className="ld_image_div_container">
                              <img
                                src={require('../Images/NewIcons/pharma benefits icon (active).svg')}
                                style={{ marginRight: '20px', width: '20px' }}
                              />
                            </div>
                            <div clas="ld_menu_name">RxSimpleShare</div>
                          </div>
                        )}
                        {this.state.isRevive && (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && (
                          <div
                            style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                            onClick={() => this.openRevie()}
                            className={`ld_menu_container ${this.props.name == 'flipt' && 'ld_menu_container_selected'}`}
                          >
                            <div className="ld_image_div_container">
                              <img
                                src={require('../Images/NewIcons/pharma benefits icon (active).svg')}
                                style={{ marginRight: '20px', width: '20px' }}
                              />
                            </div>
                            <div clas="ld_menu_name">UHSRx</div>
                          </div>
                        )}
                      </>
                    )

                  case 'CuramLifeApp':
                    return (
                     (( localStorage.getItem("planId")!=="10051" && localStorage.getItem("planId")!=="10052" && localStorage.getItem("planId")!=="10053"
                        && localStorage.getItem("planId")!=="10061" && localStorage.getItem("planId")!=="10062" && localStorage.getItem("planId")!=="10063") || (this.state.programname?.includes("ES") && this.state.isTelemed)) && <div
                          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                          onClick={() => this.openCuramLink()}
                          className={`ld_menu_container ${this.props.name == '' && 'ld_menu_container_selected'}`}
                        >
                          <div className="ld_image_div_container">
                            <img src={require('../Images/CuramLife.svg')}
                            style={{ marginLeft: '-6px', height: '34px' }} />
                          </div>
                          <div clas="ld_menu_name" style={{marginLeft:'5px'}} >CuramLife Care Coordination App</div>
                        </div>
                    )
                    
                    case 'CuramLifeCard':
                    return (
                      ( localStorage.getItem("planId")!=="10051" && localStorage.getItem("planId")!=="10052" && localStorage.getItem("planId")!=="10053"
                      && localStorage.getItem("planId")!=="10061" && localStorage.getItem("planId")!=="10062" && localStorage.getItem("planId")!=="10063") && <div
                        onClick={this.openccuramlife}
                        style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
                        class={`ld_menu_container ${this.props.name == 'CuramLifeCard' && 'ld_menu_container_selected'}`}
                      >
                        <div class="ld_image_div_container" id="curam lifeimage">
                          <img
                            src={require('../Images/CuramLife.svg')}
                            style={{ marginRight: '20px', width: '39px', marginLeft: '-6px', height: '34px' }}
                          />
                        </div>
                        <div clas="ld_menu_name">UHF / Curam Wellness Center™</div>
                      </div>
                    )
                }
              })()}
            </>
          ))}
             
 <Link
          to="/Education"
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'Member Education Panel' && 'ld_menu_container_selected'}`}
        >
          <div class="ld_image_div_container">
            <img src={require('../Images/NewIcons/member education icon (active).svg')} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">Member Education Panel</div>
        </Link>
        <div
          style={{ textDecoration: 'none', fontSize: '16px', fontWeight: 500 }}
          class={`ld_menu_container ${this.props.name == 'Sign Out' && 'ld_menu_container_selected'}`}
          onClick={this.handleSignout}
        >
          <div class="ld_image_div_container">
            <img src={require('../Images/NewIcons/logout icon (active).svg')} style={{ marginRight: '20px' }} />
          </div>
          <div clas="ld_menu_name">Sign Out</div>
        </div>
      </div>
      <Modal
          size="small" centered backdrop="static"
          show={this.state.showSSOErrorModal}
          onHide={() => this.setState({ showSSOErrorModal: false })}
        >
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
            <IconButton aria-label="close" onClick={() => this.setState({ showSSOErrorModal: false })}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>
          <Modal.Body style={{ padding: 20 }}>
            <b>{this.state.ssoErrorMessage}</b>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}
